import axios from 'axios'

export default class TipoDominios {
  constructor (tokenBearer, url) {
    this.url = url
    this.tokenBearer = tokenBearer
  }

  getTipoDominios () {
    let url = `${this.url}/api/dominios/tipoDominios`

    return new Promise(async (resolve, reject) => {
      let optionsTipoDominios = {
        method: 'get',
        url,
        headers: {
          'Authorization': this.tokenBearer
        }

      }

      try {
        let responseTipoDominio = await axios(optionsTipoDominios)
        resolve(responseTipoDominio)
      } catch (err) {
        reject(err)
      }
    })
  }
}
